module.exports = __webpack_public_path__ + "img/pig.4ff17623.svg";